import Accordion from "../Accordion/Accordion";

function MultiContent(props) {
    return (
        <>
            <section className={"multiContent " + props?.class}>
                <div className="container">
                    <div className="row">
                        {props?.left_img && (
                            <div className="col-md-6">
                                <figure className="imgCont" data-aos='fade-in' data-aos-delay='100'>
                                    <img src={process.env.PUBLIC_URL + "/images/" + props?.img_url} alt=""/>
                                </figure>
                            </div>
                        )}
                        <div className="col-md-6">
                            {props?.tag && (
                                <span data-aos='fade-in' className={`tag ${props?.tagClass}`}>
                                    {props?.tag}
                                </span>
                            )}
                            {props?.heading && (
                                props?.topHeading && (
                                    <h3 data-aos='fade-in' className="heading">{props.heading}</h3>
                                )
                            )}
                            {props?.description && props?.description.map((para, index) => (
                                <p key={index} className={`description ${props?.descClass}`} data-aos='fade-in' data-aos-delay='100'>
                                    {para}
                                </p>
                            ))}
                            {props?.heading && (
                                props?.bottomHeading && (
                                    <h3 data-aos='fade-in' data-aos-delay='150' className="heading">{props.heading}</h3>
                                )
                            )}
                            {props?.accordion && (
                                <Accordion
                                    data={props?.accordion}
                                />
                            )}
                        </div>
                        {props?.right_img && (
                            <div className="col-md-6">
                                <figure className="imgCont" data-aos='fade-in' data-aos-delay='100'>
                                    <img src={process.env.PUBLIC_URL + "/images/" + props?.img_url} alt=""/>
                                </figure>
                            </div>
                        )}
                    </div>
                    <div className="row">
                        <div className="col-md-12 fullPgPara">
                            {props?.fullPara && props?.fullPara.map((para, index) => (
                                <p key={index} className='description med'>
                                    {para}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MultiContent